module.exports = __webpack_public_path__ + "img/facebook.581d1acb.svg";